'use strict';

var RomSummaryFiltersPopupDirective = function RomSummaryFiltersPopupDirective() {
  return {
    restrict: 'E',
    template: require('../templates/rom-summary-filters.html'),
    controller: 'romSummaryFiltersController'
  };
};
RomSummaryFiltersPopupDirective.$inject = [];
module.exports = RomSummaryFiltersPopupDirective;